import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import {EncryptDecryptService} from "../encrypt-decrypt.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private encryptDecryptService: EncryptDecryptService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.getDecryptedToken();

    if (token && !request.url.includes('/public/')) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(request);
  }

  /**
   * ดึง token จาก sessionStorage และถอดรหัส
   */
  private getDecryptedToken(): string | null {
    try {
      const encryptedToken = sessionStorage.getItem('token');
      if (!encryptedToken) return null;

      const parsedToken = JSON.parse(encryptedToken);
      const token = this.encryptDecryptService.decrypt(parsedToken);
      return JSON.parse(token);
    } catch (e) {
      console.error('Error retrieving or decrypting token:', e);
      return null;
    }
  }
}
